import { Injectable } from '@angular/core';
import { ConfigService } from '@services/config.service';
import { firstValueFrom } from 'rxjs';

declare var SN_CSM_EC: any;

@Injectable()
export class ServiceNowService {
  constructor(private configService: ConfigService) {}

  private loaded = false;

  public async initialize(): Promise<void> {
    try {
      const config = await firstValueFrom(
        this.configService.getConfigValues([ConfigService.SERVICENOW_SCRIPT_URL, ConfigService.SERVICENOW_MODULE_ID]),
      );

      const scriptUrl = config[ConfigService.SERVICENOW_SCRIPT_URL];
      const moduleId = config[ConfigService.SERVICENOW_MODULE_ID];

      if (!scriptUrl || !moduleId) {
        return;
      }

      await this.loadScript(scriptUrl);

      SN_CSM_EC.init({
        moduleID: moduleId,
        loadFeature: SN_CSM_EC.loadEMFeature(),
      });

      this.loaded = true;
    } catch {
      // ServiceNow Engagement Messenger failed to load — non-critical, continue without it
    }
  }

  public onLogin(): void {
    if (this.loaded) {
      SN_CSM_EC.onLogin();
    }
  }

  public onLogout(): void {
    if (this.loaded) {
      SN_CSM_EC.onLogout();
    }
  }

  private loadScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
      document.head.appendChild(script);
    });
  }
}
